module.exports = __webpack_public_path__ + "static/hagan-18fac7c6e20aefc9190ca94282da9b03.jpg";